import React, { Component} from "react";
import { connect } from "react-redux";
import { withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {
  withRouter
} from "react-router-dom";
import {
  withStyles,
  makeStyles,
  withTheme,
} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import SwipeableViews from "react-swipeable-views";
import { logError } from "../../helpers/auth";
import ChatList from "./ChatList";
import ChatProfile from "./ChatProfile";
import PendingApplicantList from "./PendingApplicantList";
import Services from "../../api/api";
import {
  setChatType,
  setSelectedComponentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
} from "../../redux/actions/appActions";
import { gaLogEvent, gaLogScreen } from "../../helpers/analytics";
import cordovaConfig from '../../config/cordovaConfig';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

class ChatContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      value: 0,
      chatType: "group",
      tabList: [],
      adminObj: JSON.parse(localStorage.getItem('adminobj')) != null ?  JSON.parse(localStorage.getItem('adminobj')) : {}
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.roleType = JSON.parse(localStorage.getItem('obj')).roleType;
  }

  componentDidMount() {
    gaLogEvent("Chat", '', '');
    this.getTablist()
    this.checkActiveTab()
    console.log("chat component did mount");
    cordovaConfig.init();
  }

  getTablist() {
    var menuList = JSON.parse(localStorage.getItem("menuList"));
    var tab = menuList.filter(obj => obj.path == 'peerchat');
    if (tab && tab.length > 0) {
      this.setState({
        tabList: tab[0].childs.filter(obj => obj.isactive && obj.visible),
      });
    }
    // var self = this;
    // var myNotiRedPage = localStorage.getItem('notiRedPage');
    // if (myNotiRedPage) {
    //   myNotiRedPage = JSON.parse(myNotiRedPage);
    //   if (myNotiRedPage.page == '/layout/chatwindow') {
    //     self.handleChange(self, 1);
    //     localStorage.setItem('notiRedPage', '');
    //   }else if (myNotiRedPage.page == '/layout/adminchat') {
    //     self.handleChange(self, 3);
    //     localStorage.setItem('notiRedPage', '');
    //   }
    // }
  }

  checkActiveTab() {
    var activetab = JSON.parse(sessionStorage.getItem('activeTab'))
    if (activetab != null && activetab['chat'] != undefined) {
      this.setChatType(activetab['chat']);
    }
  }

  setChatType = (index) => {
    if (index == 0) {
      this.setState(
        {
          chatType: "group",
          value: index,
        },
        () => {
        }
      );
    } else if (index == 1) {
      this.setState(
        {
          chatType: "peer",
          value: index,
        },
      );
    } else if (index == 3) {
      this.setState(
        {
          chatType: "admin",
          value: index,
        },
        () => {
        }
      );
    } else {
      this.setState({
        chatType: "",
        value: index,
      });
    }

    sessionStorage.setItem('activeTab', JSON.stringify({ 'chat': index }))
  };

  handleChange(event, newValue) {

    console.log("handleChange", event, newValue);
    if (this.state.value == newValue) {
      return;
    }

    let self = this;
    if (event && event.target) {
      let eventTargetText = event.target.textContent;
    }
    self.setChatType(newValue);

    // this.setState({
    //   value: newValue,
    // });
  }

  handleChangeIndex(index, indexLatest, meta) {

    console.log("handleChangeIndex::", index)
    if (this.state.value == index) {
      return;
    }
    let chattype = "";
    switch (index) {
      case 0:
        chattype = "forum";
        // this.setState(
        //   {
        //     chatType: "forum",
        //     value: index,
        //   },
        //   () => {
        // if (this.state.value !== index) {
        this.setChatType(index);
        // }
        // }
        // );
        break;
      case 1:
        chattype = "peer";
        // this.setState(
        //   {
        //     chatType: "peer",
        //     value: index,
        //   },
        //   () => {
        // if (this.state.value !== index) {
        this.setChatType(index);
        // }
        //   }
        // );
        break;
      default:
        chattype = "";
        this.setChatType(index);
        break;
    }
  }

  gotoTab(newValue) {
    this.setState({
      value: newValue,
    });
  }

  goToGetInvolved() {
    let getInvolvedObj = {
      name: "Get Involved",
      id: 6,
      path: "services",
    };
    this.props.setBottomNavComponentObject(getInvolvedObj);
    this.props.partialSetSelectedComponentObject(getInvolvedObj);
    this.props.history.push(`/layout/${getInvolvedObj.path}`);
  }

  getSlides() {
    var arr = []
    const { t } = this.props;
    const { classes, theme } = this.props;
    var len  = this.state.tabList.length;
    if (this.state.tabList.length > 0) {
      this.state.tabList.map((tabListObj, index) => {
        var chattype = tabListObj.path  == 'adminchat' ? 'admin' : (tabListObj.path  == 'forum' ? "group" : 'peer') 
        arr.push(
          <TabPanel
            value={this.state.value}
            name="Forum"
            index={index}
            dir={theme.direction}
            className={"forum-container"}
            key={index}
          >
            {tabListObj.componentId == 28 || tabListObj.name == "user" ?
              (<ChatProfile changeTab={(val) => this.handleChangeIndex(val)} />) : (
                <ChatList compChatType={chattype} changeTab={() => this.handleChangeIndex(2)} />
              )
            }
          </TabPanel>
        )
      })
    }

    if (Object.keys(this.state.adminObj) && Object.keys(this.state.adminObj).length != 0) {
      arr.push(
        <TabPanel key={4} value={this.state.value} index={len} dir={theme.direction}>
          <PendingApplicantList />
        </TabPanel>
      )
    }

    return arr;
  }

  render() {
    const { t } = this.props;
    const { classes, theme } = this.props;
    const { templateID } = this.props;
    var len  = this.state?.tabList?.length;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { background: `url(${this.state.background})` } : {};
    var sliderArr = []
    if (this.state && this.state.tabList && this.state.tabList.length > 0) {
      sliderArr = this.getSlides()
    }

    return (
      <div className="gk-page getknowledgeable_page">

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
      
          <div className="gridcontainer">
            <Grid container spacing={3} className="gridcontainer">
              <Grid item xs={12} className="gkdivcontent zero chat-container">
                <AppBar className="tabheader" position="static" color="default" style={colorStyles}>
                  <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                  >
                    {
                      this.state && this.state.tabList && this.state.tabList.length > 0 ? (
                        this.state.tabList.map((tabListObj, index) => {
                          return (<Tab label={t(tabListObj.label)} {...a11yProps(index)} />)
                        })
                      ) : ('')
                    }
                    {/* <Tab label={t('Forum')} {...a11yProps(0)} />
                  <Tab label={t('Peer')} {...a11yProps(1)} />
                  <Tab icon={<PersonAddIcon />} label="" {...a11yProps(2)} />
                  <Tab label={t('Admin')} {...a11yProps(4)} /> */}
                    <Tab className={Object.keys(this.state.adminObj).length != 0 ? '' : 'hide'} label="Pending" {...a11yProps(len)} />

                  </Tabs>
                </AppBar>
                <SwipeableViews

                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={this.state.value}
                  onChangeIndex={this.handleChangeIndex}
                  onTransitionEnd={this.state.checkType}
                  className="infotabcontainer getaccesstabspage chat-list-swipe"
                >
                  {sliderArr}
                  {/* <TabPanel
                  value={this.state.value}
                  name="Forum"
                  index={0}
                  dir={theme.direction}
                  className={"forum-container"}
                >

                  <div className="regnotificdiv">
                    <Grid container>
                      <Grid item xs={12}>
                        <h5 className="m-0">
                          {t('Remember to report problems that you are having through')}
                        </h5>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          style={{ background: this.props.componentbgcolor }}
                          className=""
                          variant="contained"
                          color="primary"
                          disableElevation
                          onClick={() => this.goToGetInvolved()}
                        >
                          <ScheduleIcon className="mr-10" />  <span><Trans> {t("Get Involved")} </Trans></span>
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </TabPanel>
                <TabPanel
                  value={this.state.value}
                  name="Chat"
                  index={1}
                  dir={theme.direction}
                >
                  <ChatList
                    compChatType={this.state.chatType}
                    changeTab={() => this.handleChangeIndex(2)}
                  />
                </TabPanel>
                <TabPanel
                  value={this.state.value}
                  index={2}
                  dir={theme.direction}
                >
                  <ChatProfile changeTab={(val) => this.handleChangeIndex(val)} />
                </TabPanel>
                <TabPanel
                  value={this.state.value}
                  name="Chat"
                  index={3}
                  dir={theme.direction}
                >
                  <ChatList
                    compChatType={this.state.chatType}
                    changeTab={() => this.handleChangeIndex(2)}
                  />
                </TabPanel> */}

                  {/* {(this.roleType == 'Admin' || this.roleType == 'SuperAdmin') ? <TabPanel
                  value={this.state.value}
                  index={4}
                  dir={theme.direction}
                >
                  <PendingApplicantList />
                </TabPanel> : ''} */}

                </SwipeableViews>
              </Grid>
            </Grid>
          </div>

      </div>
    );
  }
}

// export default ChatContainer;

ChatContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

const TransChatContainer = withTranslation()(ChatContainer);
const ThemeChatContainer = withTheme(TransChatContainer);
const FinalChatContainer = withStyles(useStyles)(ThemeChatContainer);
const routeChatContainer = withRouter(FinalChatContainer);

export default connect(mapStateToProps, {
  setChatType,
  setSelectedComponentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
})(routeChatContainer);
